import { render, staticRenderFns } from "./DriverPendingReports.vue?vue&type=template&id=5032647a&scoped=true&"
import script from "./DriverPendingReports.vue?vue&type=script&lang=ts&"
export * from "./DriverPendingReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5032647a",
  null
  
)

export default component.exports